module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-08.35d05c6a.png";